import { render, staticRenderFns } from "./method-detail.vue?vue&type=template&id=cd1c0af0&scoped=true&"
import script from "./method-detail.vue?vue&type=script&lang=js&"
export * from "./method-detail.vue?vue&type=script&lang=js&"
import style0 from "./method-detail.vue?vue&type=style&index=0&id=cd1c0af0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1c0af0",
  null
  
)

export default component.exports